let savedViewContainerObj = JSON.parse(localStorage.getItem("savedViewContainer"));


var StateData = {

  selectFilterValue : 'all',

  objectAllFilterArray: [{
   "name": "QualaUSA-Quala USA",
   "value": "QualaUSA",
   catName: "Facility",
   catShortName:"FA"
 },
 {
   "name": "256-Cedar Rapids IA",
   "value": "256",
   catName: "Facility",
   catShortName:"FA"
 },
 {
   "name": "286-Joliet IL",
   "value": "286",
   catName: "Facility",
   catShortName:"FA"
 }],

 
  objectAllFAArray: [
   {
      "name": "QualaUSA-Quala USA",
      "value": "QualaUSA",
      catName: "Facility",
      catShortName:"FA"
    },
    {
      "name": "256-Cedar Rapids IA",
      "value": "256",
      catName: "Facility",
      catShortName:"FA"
    },
    {
      "name": "286-Joliet IL",
      "value": "286",
      catName: "Facility",
      catShortName:"FA"
    },
    {
      "name": "115-Charlotte NC",
      "value": "115",
      catName: "Facility",
      catShortName:"FA"
    },
    {
      "name": "106-Concord ON",
      "value": "106",
      catName: "Facility",
      catShortName:"FA"
    },
    {
      "name": "107-Granite City IL",
      "value": "107",
      catName: "Facility",
      catShortName:"FA"
    },
    {
      "name": "288-Albany NY",
      "value": "288",
      catName: "Facility",
      catShortName:"FA"
    },
    {
      "name": "117-Sarnia ON",
      "value": "117",
      catName: "Facility",
      catShortName:"FA"
    },
  ],

  objectAllCuArray:[

    {
      "name": "ChampionX LLC.",
      "value": "ChampionX LLC.",
      catName: "Customer name",
      catShortName:"Cu"
    },
    {
      "name": "3D Corporate Solutions LLC (Retail)",
      "value": "10003",
      catName: "Customer name",
      catShortName:"Cu"
    },
    {
      "name": "DRPAMJ Transport",
      "value": "14166",
      catName: "Customer name",
      catShortName:"Cu"
    },
    {
      "name": "Behrens Trucking",
      "value": "13549",
      catName: "Customer name",
      catShortName:"Cu"
    },
    {
      "name": "RRM Trucking",
      "value": "14256",
      catName: "Customer name",
      catShortName:"Cu"
    },
    {
      "name": "NCT Truck & Trailer",
      "value": "13977",
      catName: "Customer name",
      catShortName:"Cu"
    },
    {
      "name": "Truck Logistic Service",
      "value": "14003",
      catName: "Customer name",
      catShortName:"Cu"
    },
    {
      "name": "Epic Trans",
      "value": "13972",
      catName: "Customer name",
      catShortName:"Cu"
    },
  ],


  objectAllCCArray: [
     {
      "name": "Stolt-Nielson USA",
      "value": "1012",
      catName: "Bpcategory",
      catShortName:"CC"
    },
    {
      "name": "LTC Network",
      "value": "1008",
      catName: "Bpcategory",
      catShortName:"CC"
    },
    {
      "name": "HD Industrial",
      "value": "1127",
      catName: "Bpcategory",
      catShortName:"CC"
    },
    {
      "name": "Transliquids",
      "value": "1009",
      catName: "Bpcategory",
      catShortName:"CC"
    },
    {
      "name": "Best Transportation Services",
      "value": "1002",
      catName: "Bpcategory",
      catShortName:"CC"
    },
    {
      "name": "Bulkhaul USA",
      "value": "1003",
      catName: "Bpcategory",
      catShortName:"CC"
    },
  ],


  objectAllSPArray : [ { name: 'Non-Haz', value: 'Non-Haz', catName: "Service plan",
  catShortName:"SP" },
  { name: 'Presteam', value: 'Presteam', catName: "Service plan",
  catShortName:"SP" },
  { name: 'Detergent', value: 'Detergent', catName: "Service plan",
  catShortName:"SP" },
  { name: 'HWR', value: 'HWR', catName: "Service plan",
  catShortName:"SP" },
  { name: 'DRY', value: 'DRY', catName: "Service plan",
  catShortName:"SP" }],

  objectAllDOCArray:[
   { name: 'None', value: ' ' ,  catName: "Document type",
   catShortName:"DOC"  },
   { name: 'IBC Outbound', value: 'IBC Outbound', catName: "Document type",
   catShortName:"DOC" },
   { name: 'IBC Inbound', value: 'IBC Inbound', catName: "Document type",
   catShortName:"DOC" },
   { name: 'IBCBILL', value: 'IBCBILL', catName: "Document type",
   catShortName:"DOC" },
],

objectAllPCArray: [
   { name: 'Interior (ISO)', value: 'Interior (ISO)',  catName: "Product category",
   catShortName:"PC" },
   { name: 'Labor (ISO)', value: 'Labor (ISO)', catName: "Product category",
   catShortName:"PC" },
   { name: 'No Wash (ISO)', value: 'No Wash (ISO)', catName: "Product category",
   catShortName:"PC" },
   { name: 'Fees (TANK)', value: 'Fees (TANK)', catName: "Product category",
   catShortName:"PC" },
   { name: 'Fees (Waste Water)', value: 'Fees (Waste Water)', catName: "Product category",
   catShortName:"PC" },
   { name: 'Fees (Specialty Tanks)', value: 'Fees (Specialty Tanks)', catName: "Product category",
   catShortName:"PC" },
   { name: 'Accessorial (ISO)', value: 'Accessorial (ISO)', catName: "Product category",
   catShortName:"PC" },
],

objectAllLBArray: [
   {
      "name": "Tank",
      "value": "Tank",
      catName: "Line of business",
      catShortName:"LB"
    },
    {
      "name": "Dry Bulk",
      "value": "Dry Bulk",
      catName: "Line of business",
      catShortName:"LB"
    },
    {
      "name": "Box Trailer",
      "value": "Box Trailer",
      catName: "Line of business",
      catShortName:"LB"
    },
    {
      "name": "Rail",
      "value": "Rail",
      catName: "Line of business",
      catShortName:"LB"
    },
    {
      "name": "Roll Off",
      "value": "Roll Off",
      catName: "Line of business",
      catShortName:"LB"
    },
    {
      "name": "Frac Tank",
      "value": "Frac Tank",
      catName: "Line of business",
      catShortName:"LB"
    },
    {
      "name": "Waste Water",
      "value": "Waste Water",
      catName: "Line of business",
      catShortName:"LB"
    },
    {
      "name": "Intermodal",
      "value": "Intermodal",
      catName: "Line of business",
      catShortName:"LB"
    },
    {
      "name": "IBC",
      "value": "IBC",
      catName: "Line of business",
      catShortName:"LB"
    },
    {
      "name": "ISO-Old",
      "value": "ISO-Old",
      catName: "Line of business",
      catShortName:"LB"
    },
    {
      "name": "COMP",
      "value": "COMP",
      catName: "Line of business",
      catShortName:"LB"
    },
    {
      "name": "ISO",
      "value": "ISO",
      catName: "Line of business",
      catShortName:"LB"
    },
    {
      "name": "Industrial Services",
      "value": "Industrial Services",
      catName: "Line of business",
      catShortName:"LB"
    },

],



  
  selectedAllValue : [],
  loading: false,
  visible: true,
  isTourOpen: false,
  // savedViewContainerItemForEdit:[],
  showSavedViews: false,
  showFilters: true,
  showHideOverAllFilters: true,
  showCreateSavedView: false,
  editMode: false,
  filterId: '',
  filterName: '',
  filterDescription: '',
  storedFilters: savedViewContainerObj,
  filtersTitleName: "Filters",
  displayFilterValue: "workorders",
  // displayFilterValue: "facility",
  optionsForTimeFilter: [
    { name: 'Work Order Start Date', value: 'WorkOrder.start_date' },
    { name: 'Work Order End Date', value: 'WorkOrder.enddate' },
  ],
  optionsForDateRange: [
    { name: 'All time', value: undefined },
    { name: 'Today', value: 'today' },
    { name: 'Yesterday', value: 'Yesterday' },
    { name: 'This week', value: 'This week' },
    { name: 'This month', value: 'This month' },
    { name: 'This quarter', value: 'This quarter' },
    { name: 'This year', value: 'This year' },
    { name: 'Last 30 days', value: 'Last 30 days' },
    { name: 'Last week', value: 'Last week' },
    { name: 'Last month', value: 'Last month' },
    { name: 'Last quarter', value: 'Last quarter' },
    { name: 'Last year', value: 'Last year' },
  ],
  optionsForGranularityList: [
    { name: 'w/o time slice', value: null },
    { name: 'Hour', value: 'hour' },
    { name: 'Day', value: 'day' },
    { name: 'Week', value: 'week' },
    { name: 'Month', value: 'month' },
    { name: 'Year', value: 'year' }
  ],
  optionsForWidgetLimit: [
    { name: 'All', value: '1000' },
    { name: '1', value: '1' },
    { name: '2', value: '2' },
    { name: '3', value: '3' },
    { name: '4', value: '4' },
    { name: '5', value: '5' }
  ],
  facilityList:['286'],  // ['101'],
  bPCategoryList:[],  // ['LTC Network'],
  bpNameList: [], // ["Nalco Chemical Company"],
  lineOfBusinessList: [], // ["Tank"],
  productCategoryList: [], // ["Tank"],
  doctypeList: [], // ["AP CreditMemo"],  //   { name: 'IBC Outbound', value: 'IBC Outbound' },
  serviceList: [],
  timeDimension: 'WorkOrder.enddate', // WorkOrder.enddate    // ['Work Order Enddate'],
  // dateRangeList: 'This month', // undefined,  // For
  dateRangeList: 'This year',
  granularityList: null, // BY
  limitInWidget: 1000,

  selectedFacilityValue: ['286'],
  selectedValueBPCategory: [], // [{ name: 'LTC Network', value: 'LTC Network' } ],
  selectedValueBPName: [], // [{ name: 'Wolf Pack Transport', value: 'Wolf Pack Transport' }],
  selectedValueLineOfBusiness: [], // [ { name: 'Tank', value: 'Tank' }],
  selectedValueProductCategory: [], // [{ name: 'Tank', value: 'Tank' }],
  selectedValueDoctype: [],  // [ { name: 'AP CreditMemo', value: 'AP CreditMemo' },], 
  selectedServiceValue: [],
  selectedTimeFilterValue: [{ name: 'Work Order End Date', value: 'WorkOrder.enddate' }],
  selectedDateRangeList: [{ name: 'This year', value: 'This year' }],
  selectedGranularityList: [{ name: 'w/o time slice', value: 'w/o grouping' }]
};


module.exports = StateData;